import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    EntityCacheDispatcher,
    EntityCollectionServiceElementsFactory,
    HttpUrlGenerator,
    Logger,
    QueryParams
} from '@ngrx/data';
import { Observable } from 'rxjs/Observable';
import { WebsocketBrokerService } from '../../../../core/services/websocket-broker.service';
import { WebSocketEntityCollectionServiceBase } from '../../../../state/entity/web-socket-entity-collection-service-base';
import { RecallsDashboardEntityDataServiceBase } from './recalls-dashboard-entity-data-service.base';
import { recallsDashboardEntityMetadata, RecallsDashboardQueryFilter } from './recalls-dashboard.entity';

@Injectable()
export class RecallsDashboardService extends WebSocketEntityCollectionServiceBase<any> {

    refreshing$: Observable<boolean>;
    queryFilter$: Observable<RecallsDashboardQueryFilter>;
    totalRecallsCount$: Observable<number>;

    constructor(private http: HttpClient,
                private serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super(recallsDashboardEntityMetadata.entityName, serviceElementsFactory);
        this.refreshing$ = this.selectors$['refreshing$'];
        this.queryFilter$ = this.selectors$['queryFilter$'];
        this.totalRecallsCount$ = this.selectors$['totalRecallsCount$'];
    }
}
/**
 * This is the data service NgRx Data will use to call from effects to make the actual calls to the backend.
 */
@Injectable()
export class RecallsDashboardEntityDataService extends RecallsDashboardEntityDataServiceBase<any> {
    constructor(http: HttpClient,
                httpUrlGenerator: HttpUrlGenerator,
                logger: Logger,
                public entityCacheDispatcher: EntityCacheDispatcher,
                public websocketBrokerService: WebsocketBrokerService) {
        super(http, httpUrlGenerator, logger, entityCacheDispatcher, websocketBrokerService,
            'RecallsDashboard', 'recalls-dashboard/');
        logger.log('Created custom Recalls Dashboard');
    }

    subscribeWebSocketJob(parameters: any | QueryParams): void {
        this.subscribeWebSocketJobWithBody({parameters});
    }

    refreshWebSocketJob(parameters: any | QueryParams): void {
        this.refreshWebSocketJobWithBody({parameters});
    }
}
